import { combineReducers } from 'redux';

import roundPlayReducer from './reducers/roundPlayReducer';
import screenReducer from './reducers/screenReducer';
import sessionReducer from './reducers/sessionReducer';
import dropZoneReducer from './reducers/dropZoneReducer';
import dragReducer from './reducers/dragReducer';
import tabsReducer from './reducers/tabsReducer';
import canvasReducer from './reducers/canvasReducer';
import historyReducer from './reducers/historyReducer';
import gameDataReducer from './reducers/gameDataReducer';

export const reducerCollection = {
  screen: screenReducer,
  roundPlay: roundPlayReducer,
  session: sessionReducer,
  dropZone: dropZoneReducer,
  drag: dragReducer,
  tabs: tabsReducer,
  canvas: canvasReducer,
  history: historyReducer,
  gameData: gameDataReducer,
};

const reducers = combineReducers({ ...reducerCollection });

export default reducers;
